<template>
  <section v-if="isAdmin" class="ine-form">
    <div class="ine-form__background">
      <img class="ine-form__logo" src="@/assets/images/home-logo.png" />
    </div>
    <div class="ine-form__form-wrapper">
      <Impersonate
        v-if="currentMode === 'impersonate-user'"
        :emailValid="currentEmailValid"
        @emailTest="emailTest"
      ></Impersonate>
      <SuspendUser
        v-if="currentMode === 'manage-user-suspension'"
        :emailValid="currentEmailValid"
        @emailTest="emailTest"
      ></SuspendUser>
      <ResetPassword
        v-if="currentMode === 'manage-user-password'"
        :emailValid="currentEmailValid"
        @emailTest="emailTest"
        :passwordValid="passwordValid"
        @passwordTest="passwordTest"
      />
      <ConfirmUser
        v-if="currentMode === 'manage-user-confirmation'"
        :emailValid="currentEmailValid"
        @emailTest="emailTest"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Admin',
  data() {
    return {
      currentEmailValid: false,
      passwordValid: false,
    }
  },
  computed: {
    ...mapGetters({
      userId: 'auth/userId',
      isAdmin: 'auth/isAdmin',
    }),
    currentMode() {
      return this.$route.params.mode
    },
  },
  components: {
    Impersonate: () => import('../components/admin/Impersonate'),
    SuspendUser: () => import('../components/admin/SuspendUser'),
    ResetPassword: () => import('../components/admin/ResetPassword'),
    ConfirmUser: () => import('../components/admin/ConfirmUser'),
  },
  methods: {
    emailTest(value) {
      // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // this.currentEmailValid = pattern.test(value)
      this.currentEmailValid = value.length >= 1
    },
    passwordTest(value) {
      const uppercase = /[A-Z]/g
      const numbers = /[0-9]/g
      if (value.length >= 8 && value.match(numbers) && value.match(uppercase)) {
        this.passwordValid = true
      } else {
        this.passwordValid = false
      }
    },
  },
  created() {
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>
